/* eslint-disable */
<template>
  <div class="specialists">
    <AdminNavigation ref="navigation" indexProps="3"/>
    <div class="top-panel">
      <Header/>
      <div class="header-title-section">
        <div class="header-title"><h1>Practice Manager</h1></div>
<!--        <div class="header-sub-title"><span class="search-title" v-html="searchTitle"></span></div>-->
      </div>
    </div>
    <div class="panel">
      <AdminSpecialistMenu :key="specialistMenuIndex" :indexProps="specialistMenuIndex"/>
      <div class="content">
        <div class="tool-bar row">
          <div class="col">
            <div class="icon-group right-float-element">
              <div class="d-inherit">
                <el-input @input="search()" clearable placeholder="Specialist Name" v-model="listParam.SpecialistName"/>
                <el-input @input="search()" clearable class="ml-2" placeholder="Manager Name" v-model="listParam.PracticeManagerName"/>
                <el-input @input="search()" clearable class="ml-2" placeholder="Email" v-model="listParam.EmailAddress"/>
              </div>
              <router-link :to="{ name: 'admin-manage-practice-manager', query: {} }">
                <v-btn class="add-icon" dark>Add New</v-btn>
              </router-link>
            </div>
          </div>
        </div>

        <div class="content-scroll-x">
          <div>
            <el-table @row-click="openSpecialist" :default-sort="{prop: 'PracticeManagerName', order: 'descending'}"
                      :data="specialists" stripe @sort-change="sortParam" tooltip-effect="dark"
                      :header-row-style="{background: '#fde9eb', height: '70px'}"
                      :header-cell-style="{fontWeight: 100}">
              <el-table-column
                  width="80"
                  show-overflow-tooltip
                  label="ID"
                  prop="PracticeManagerID"
                  sortable="custom"
              >
              </el-table-column>
              <el-table-column
                  width="200"
                  show-overflow-tooltip
                  label="Name"
                  sortable="PracticeManagerName"
                  prop="PracticeManagerName"
              >
                <template slot-scope="scope">
                  <span>{{decodeURIComponent(scope.row.FirstName + ' ' + scope.row.Surname)}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  label="Email"
                  sortable="custom"
                  prop="EmailAddress"
              >
              </el-table-column>
              <el-table-column
                  show-overflow-tooltip
                  label="Specialists"
                  prop="SpecialistName"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.FullName.join(', ')}}</span>
                </template>
              </el-table-column>
              <el-table-column
                  width="180"
                  show-overflow-tooltip
                  label="Created Time"
                  prop="CreatedTime"
                  sortable="custom"
              >
                <template slot-scope="scope">
                  <span>{{ formatDate(scope.row.CreatedTime, "DD/MM/YYYY hh:mm A", "YYYY-MM-DD HH:mm:ss.ssss") }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-if="totalCount > listParam.pageSize" class="pagination">
          Page
          <div class="pagination-group">
            <div class="border-icon pagination-current dropdown">
              <div class="pagination-current-text">{{ listParam.pageNum }}</div>
              <div class="pagination-current-icon" data-toggle="dropdown" aria-haspopup="true"
                   aria-expanded="false"></div>
              <div class="dropdown-menu shadow" aria-labelledby="pagination-current-icon">
                <div class="dropdown-item" v-for="item in (1, Math.ceil(totalCount/listParam.pageSize))" :key="item"
                     :class="listParam.pageNum === item ? 'selected' : ''" :value="item" @click="selectPage(item)">
                  {{ item }}
                </div>
              </div>
            </div>
          </div>
          <div class="pagination-total">of &nbsp; {{ Math.ceil(totalCount / listParam.pageSize) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import utilities from '@/assets/js/utilities'
import AdminNavigation from '@/components/AdminNavigation'
import AdminSpecialistMenu from '@/components/AdminSpecialistMenu'
import Header from '@/components/Header'
import {debounce} from 'lodash'

export default {
  name: 'AdminPracticeManagers',
  components: {
    AdminNavigation,
    AdminSpecialistMenu,
    Header,
  },
  data() {
    return {
      dialogVisible: false,
      fetchedData: false,
      specialists: [],
      allSpecialists: [],
      selectedSpecialists: [],
      limit: 20,
      pagination: utilities.initPagination(),
      specialistMenuIndex: 3,
      searchParam: {},
      // ASC (true) with down icon (false), DESC (false) with up icon (true)
      byName: false,
      byNextAvailability: false,
      byLastAvailability: false,
      fromSearch: false,
      useSearch: false,
      listParam: {
        pageSize: 10,
        pageNum: 1,
        orderBy: 'PracticeManagerName',
        ascOrDesc: 'DESC',
        PracticeManagerName: '',
        EmailAddress: '',
        SpecialistName: ''
      },
      totalCount: 0,
    }
  },
  computed: {
    user() {
      return this.$store.getters['user/getUser'];
    },
  },
  methods: {
    sortParam( v ) {
      this.listParam.orderBy = v.prop
      if(v.order === "ascending") {
        this.listParam.ascOrDesc = 'ASC'
      } else if (v.order === "descending") {
        this.listParam.ascOrDesc = 'DESC'
      } else {
        this.listParam.orderBy = null
        this.listParam.ascOrDesc = null
      }

      this.selectPage(1)
    },

    async onChangeUserActive(scope) {
      await this.$store.dispatch('loading/setLoadComponent', true)
      await utilities.putPracticeManagerActive(scope.row.PracticeManagerID, scope.row.Active ? 0 : 1)
      scope.row.Active = scope.row.Active ? 0: 1
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
    getSpecialistFullName(specialist) {
      return utilities.getSpecialistFullNameUpper(specialist)
    },
    search: debounce(function () {
      this.selectPage(1)
    }, 800),

    selectPage(index) {
      this.listParam.pageNum = index
      this.loadData()
    },

    formatDate(dateToFormat, newFormat) {
      if (!dateToFormat) return ''
      return window.moment(dateToFormat).format(newFormat)
    },

    openSpecialist({PracticeManagerID}) {
      if (this.fromSearch) {
        let routeData = this.$router.resolve({name: 'admin-manage-practice-manager', query: {id: PracticeManagerID}});
        window.open(routeData.href, '_blank');
      } else {
        this.$router.push({name: 'admin-manage-practice-manager', query: {id: PracticeManagerID}})
      }
    },
    paging() {
      utilities.disposeTooltip()
      utilities.initTooltip()
      utilities.hoverTooltip()
    },

    async loadData() {
      await this.$store.dispatch('loading/setLoadComponent', true)
      let obj = {...this.listParam}
      for (let key in obj) {
        if (obj[key] === null || obj[key] === '') {
          delete obj[key];
        }
      }
      const {data, total} = await utilities.getPractiseManagers(obj)
      data.forEach((item) => {
        item.FullName = item.Specialists ? item.Specialists.map(i => utilities.getSpecialistFullNameUpper(i)) : []
      })
      console.log(data)
      this.specialists = data
      this.totalCount = total
      await this.$store.dispatch('loading/setLoadComponent', false)
    },
  },
  async beforeMount() {
    await this.loadData()
    this.fetchedData = true
  },
  mounted() {
    $('.pagination').hide()
  },
}
</script>
